import { Component, OnInit } from '@angular/core';
import {
  Router,
  ActivatedRoute,
  NavigationEnd,
  RoutesRecognized,
} from '@angular/router';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-authentification',
  templateUrl: 'authentification.component.html',
  styleUrls: ['authentification.component.css'],
})
export class AuthentificationComponent implements OnInit {
  returnUrl: string;
  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    this.returnUrl =
      '?returnUrl=' + this.route.snapshot.queryParams['returnUrl'] || '';
  }

  public goTop() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    this.router.navigateByUrl('/login' + this.returnUrl);
  }
}
